import { Button, Description, Guide } from '@zenterprise-inc/ui';

import IllustProgram from '@/assets/illust-icons/fill-p-program.svg';

interface Props {
  handleDownload: () => void;
  handleClick: () => void;
}

const IndisProgramDownloadCompleteGuide = ({ handleDownload, handleClick }: Props) => {
  return (
    <>
      <Guide>
        <Guide.ImageArea>
          <IllustProgram width={80} height={80} />
        </Guide.ImageArea>
        <Guide.TextArea>
          <Guide.Description>
            <div className="text-16">
              프로그램 설치를 완료한 후<br />
              다음 단계를 진행해주세요
            </div>
          </Guide.Description>
        </Guide.TextArea>
      </Guide>

      <div className="pb-5" />

      <Description.Section
        text={
          <div className="flex max-w-[520px] items-center justify-center">
            <span className="body-14 mr-[10px] text-gray-700">다운로드가 완료되지 않았나요?</span>
            <Button.Box state={'secondary'} size={'small'} onClick={handleDownload}>
              프로그램 다운로드
            </Button.Box>
          </div>
        }
        bgType={'BgTransparent'}
      />
      <Button.StickyBottom.Wrapper className="page-padding">
        <Button.StickyBottom.Button state="primary" onClick={handleClick}>
          설치를 완료했어요
        </Button.StickyBottom.Button>
      </Button.StickyBottom.Wrapper>
    </>
  );
};

export default IndisProgramDownloadCompleteGuide;
